import { useLocale } from './useLocale';

export const useDate = () => {
  const { locale } = useLocale();
  const intlDate = (date?: Date | number | string, options?: Intl.DateTimeFormatOptions) => {
    const formattedDate = date ? new Date(date) : undefined;
    return new Intl.DateTimeFormat(locale, options).format(formattedDate);
  };

  const formatDate = (
    date?: string | Date,
    type?: 'with-time' | 'default',
    dateStyle?: 'medium' | 'long',
  ) => {
    const options: Intl.DateTimeFormatOptions = {
      dateStyle: dateStyle ?? 'long',
      timeStyle: type === 'with-time' ? 'short' : undefined,
    };
    return intlDate(date, options);
  };

  return { formatDate };
};
